import React from "react";
import user from "../../Common/JsonFiles/simran.json";

import Button from "../../Common/Button/Button";
import "./About.scss";
import { AllImages } from "../../Assets/Images/AllImages";
import pdf from "../../Common/JsonFiles/simranCV.json";
import {val} from "../../test";

const About = (props) => {
 
  const downloadCV = () => {
    const linkSource = `data:application/pdf;base64,${pdf.base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `${user.name}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };
  return (
    <div className={`about-main-container `}>
      <div className={`${props?.theme}`}>
        <div class="row a-i-c">
          <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 img-div">
            {/* <img src={AllImages.simran} alt="" /> */}
            <img src={AllImages.simran} alt="" />
          </div>
          <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 info-div">
            <p>{user.description} </p>
            <div className="d-flex align-i-c">
              <h5>Hobbies: </h5>
              <p className="d-flex hobbies">
                {user?.hobbies
                  ?.map((item) => item)
                  .toString()
                  .replaceAll(",", ", ")}
              </p>
            </div>
            <Button name="Download CV" onClick={() => downloadCV()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
